export const SELECT_FILTER_MIN_ITEMS_COUNT: number = 5;

export const SELECT_DROPDOWN_DEFAULT_MAX_HEIGHT: number = 110;
